import React from "react";
import { jsonKeyMapping } from "../../../Config/Constants";
import { TemplateObject } from "../../../Models/TemplateObject";
import FaqComponent from "../../Shared/FaqComponent";
import PreviewComponent from "../../Shared/PreviewComponent";
import Template from "../../Template/Template";

type Props = {
  template: string;
  stepDetails: TemplateObject;
};

const FormPreview = ({ template, stepDetails }: Props) => {
  return (
    <>
      {stepDetails[jsonKeyMapping.FORM_GROUP] &&
        stepDetails[jsonKeyMapping.FORM_GROUP].length > 0 && (
          <div className="col-lg-3 previewdisplay lgwidth">
            {/* Fixed 270px container that wraps both preview and buttons */}
            <div className="preview-container-wrapper">
              {/* Template component renders its own content structure */}
              <Template templateKey={template} isInnerPage />

              {/* The buttons container */}
              <div className="preview-faq-btn-container">
                <PreviewComponent />
                {stepDetails[jsonKeyMapping.FAQ] &&
                  stepDetails[jsonKeyMapping.FAQ].length > 0 && (
                    <FaqComponent
                      faqContentList={stepDetails[jsonKeyMapping.FAQ]}
                    />
                  )}
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default FormPreview;
